import { ActivatedRoute } from '@angular/router';
import { UrlParamsModel } from '../../models/LocalServiceModels/UrlParamsModel';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class UrlParamService {
    constructor(activatedRoute) {
        this.activatedRoute = activatedRoute;
        this.UUID = "UUID";
        this.Source = "source";
        this.Agent = "Agent";
        this.Lang = "lang";
        this.Token = "token";
        this.State = "state";
    }
    getURLParams() {
        var agentCode = this.activatedRoute.snapshot.queryParams[this.Agent];
        var uuid = this.activatedRoute.snapshot.queryParams[this.UUID];
        var source = this.activatedRoute.snapshot.queryParams[this.Source];
        var lang = this.activatedRoute.snapshot.queryParams[this.Lang];
        var token = this.activatedRoute.snapshot.queryParams[this.Token];
        var state = this.activatedRoute.snapshot.queryParams[this.State];
        this.UrlParams = new UrlParamsModel(agentCode, uuid, source, lang, token, state);
    }
}
UrlParamService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UrlParamService_Factory() { return new UrlParamService(i0.ɵɵinject(i1.ActivatedRoute)); }, token: UrlParamService, providedIn: "root" });
